import React, { useContext, useEffect, useReducer } from "react";

import MaterialTable from "material-table";
import tableIcons, { options } from "components/universal/table_attributes";
import TableAction from "actions/table_actions";
import tableReducer, { INITIAL_TABLE_STATE } from "reducers/table_reducer";
import MROButton from "components/buttons";
import clxc from "clsx";
import { ToastMessageContext } from "lib/contexts/message_context";
import moment from 'moment'
import { formatMMMDate } from "lib/utils/common_utils";
import { Box, Button, FormControl, IconButton, InputBase, makeStyles, MenuItem, Select, Tab, Tabs, Grid, Typography } from "@material-ui/core";
import SearchBarWithFilters from "components/search_with_filters";
import useDebounce from "lib/utils/debounce";
import { useState } from "react";
import { BASE_API_URL_BOXR } from "lib/constants";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { ICON_COLOUR } from "lib/constants/style_constants";
import GearRed from "assets/gear-red.svg";
import CheckGreen from "assets/green_filled_tick.png";
import AllIcon from "assets/AllTextIcon.svg";





const useStyles = makeStyles(() => ({
  bookedOut: {
    borderColor: "#4D4F5C",
    borderRadius: "7px",
    minWidth: "20px",
    height: "30px",
    color: "#fff",
    backgroundColor: "#FF0202",
    width: "80px",
  },
  stockBtn2: {
    borderColor: "#4D4F5C",
    borderRadius: "7px",
    minWidth: "20px",
    height: "30px",
    color: "#fff",
    backgroundColor: "#4FC605",
    width: "80px",
  },
  tabs: {
    minHeight: "36px",
    "& .MuiTab-root": {
      borderRadius: "2px",
      minHeight: "36px",
      minWidth: "36px",
      boxShadow: "1px 1px 3px #00000044",
    },
    "& .MuiTabs-flexContainer": {
      gap: "0.75rem",
      padding: "0.25rem",
    },
    "& .MuiTab-textColorInherit": {
      opacity: 1,
    },
  },
}));

function ToolingTable(props) {
  const classes = useStyles()
  const { currentSelectedOrder } = props;
  const message = useContext(ToastMessageContext);
  const [searchText, setSearchText] = useState(null);
  const debouncedSearchText = useDebounce(searchText);
  const [statusFilter, setStatusFilter] = useState("All");
  const [tableState, dispatch] = useReducer(tableReducer, INITIAL_TABLE_STATE);
  const { page, totalCount, pageSize, inProgress, data } = tableState;

  const getList = () => {
    const params = {
      // reportable_type: "WorkshopOrder",
      workshop_order_id: currentSelectedOrder.id,
      page: 1 + page,
      count_per_page: pageSize,
      return_status: true,
      search_keyword: debouncedSearchText,
      filter_status: statusFilter,
    };
    TableAction.getList(
      dispatch,
      message,
      params,
      "workshopToolingRequestPart"
    );
  };

  useEffect(() => {
    getList();
  }, [page, pageSize, statusFilter, debouncedSearchText]);

  const tableOptions = {
    ...options,
    page: page,
    search: false,
    total: totalCount,
    pageSize: pageSize,
    toolbar: false,
  };

  const columnConfig = [
    {
      title: "",
      field: "id",
      width: "4%",
      render: (rowData) => <span>&nbsp;</span>,
    },
    {
      title: "Tool #",
      field: "tool_id",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        padding: "10px 5px",
      },
    },
    {
      title: "Part #",
      field: "part",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
      },
    },
    {
      title: "Description",
      field: "description",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        width: "30%",
      },
    },
    {
      title: "Cal Due",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left"
      },
      render: (rowData) => {
        if (rowData.calibration_due === null) {
          return "-"
        } else {
          return formatMMMDate(rowData?.calibration_due)
        }
      }
    },
    {
      title: "Cert",
      field: "user",
      headerStyle: {
        textAlign: "center",
      },
      render: (rowData) => {
        return (
          <IconButton onClick={() => {
            if (rowData?.calibration_certificate !== null) {
              window.open(BASE_API_URL_BOXR + "/" + rowData?.calibration_certificate)
            } else {
              message.showToastMessage({
                message: "No Document Found.",
                variant: "error",
              });
            }
          }}
            size="small"
            style={{ display: rowData?.calibration_certificate === null ? "none" : "" }}
          >
            <VisibilityIcon fontSize="small" color={ICON_COLOUR} />
          </IconButton>
        );
      }
    },
    {
      title: "User",
      field: "booked_out_user_stamp_number",
      headerStyle: {
        textAlign: "center",
      },
    },
    {
      title: "Booked Out",
      headerStyle: {
        textAlign: "center",
      },
      render: (rowData) => {
        if (rowData.booked_out_timestamp === null) {
          return "-"
        } else {
          return formatMMMDate(rowData?.booked_out_timestamp)
        }
      }
    },
    {
      title: "Returned",
      headerStyle: {
        textAlign: "center",
      },
      render: (rowData) => {
        if (rowData.returned_timestamp === null) {
          return "-"
        } else {
          return formatMMMDate(rowData?.returned_timestamp)
        }
      }
    },
    {
      title: "Status",
      render: (rowData) => {
        if (rowData?.status === "returned") {
          return (
            <MROButton
              className={clxc(classes.button, "button-info", classes.stockBtn2)}
              variant="contained"
            >
              <Typography
                style={{
                  fontSize: "10px",
                  color: "white",
                  textTransform: "capitalize",
                }}
              >
                RETURNED
              </Typography>
            </MROButton>
          );
        } else {
          return (
            <Box m={0} p={0}>
              <MROButton
                className={clxc(classes.button, "button-info", classes.bookedOut)}
                variant="contained"
                style={{ whiteSpace: "nowrap" }}
              >
                <Typography
                  style={{
                    fontSize: "10px",
                    color: "white",
                    textTransform: "capitalize",
                  }}
                >
                  BOOKED OUT
                </Typography>
              </MROButton>
            </Box>
          );
        }
      },
    },
  ];


  const iconStyle = { height: "20px" };

  // Config array for icons and their alt text
  const tabConfig = [
    { src: AllIcon, alt: "All" },
    { src: GearRed, alt: "Red" },
    { src: CheckGreen, alt: "Green" },
  ];

  const handleFilterChange = (keyItem, value) => {
    TableAction.setPage(dispatch, 0);
    setStatusFilter(value);
  };






  return (
    <>
      <SearchBarWithFilters
        handleSearch={(value) => {
          TableAction.setPage(dispatch, 0);
          setSearchText(value);
        }}
        searchText={searchText}
        autoFocus={false}
      >
        <Grid style={{ display: "flex", justifyContent: "end", marginTop: "-17px" }} container>
          <FormControl style={{ textAlign: "right" }}>


            <Tabs
              value={statusFilter}
              onChange={handleFilterChange}
              indicatorColor="primary"
              className={classes.tabs}
            >
              {tabConfig.map(({ src, alt }, index) => (
                <Tab key={index} value={alt} icon={<img src={src} alt={alt} style={iconStyle} />} />
              ))}
            </Tabs>

          </FormControl>
        </Grid>


      </SearchBarWithFilters>
      <MaterialTable
        style={{ marginTop: 20 }}
        columns={columnConfig}
        icons={tableIcons}
        title=""
        data={data.data || []}
        isLoading={inProgress}
        options={tableOptions}
        onChangePage={(page) => {
          TableAction.setPage(dispatch, page);
        }}
        onChangeRowsPerPage={(pageSize) => {
          TableAction.setPageSize(dispatch, pageSize);
        }}
        onSearchChange={(search) => {
          TableAction.setSearchText(dispatch, search);
        }}
        totalCount={totalCount}
        page={page}
      />
    </>
  );
}

export default ToolingTable;
